import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Controller } from 'react-hook-form';
import { CopySignIcon } from './icons/IconProvider';
import Datepicker from 'react-tailwindcss-datepicker';
const FormInput = ({
  label,
  name,
  register,
  errors,
  type = 'text',
  placeholder = '',
  options = [],
  disabled = false,
  required = false,
  readOnly = false,
  valueToCopy = '',
  showCopy = false,
  min,
  max,
  onChange,
  minDate,
  control,
  append = null,
  onCopy = () => {},
  value,
  className = '',
  labelClassName = '',
  ...rest
}) => {
  const hasError = errors?.[name];

  return (
    <div className="mb-4">
      {type !== 'checkbox' && label && (
        <p className={`text-sm md:text-md mb-2 ${labelClassName}`}>
          {label}
          {required && <span className="text-red-500 text-sm ml-1">*</span>}
        </p>
      )}
      {type === 'checkbox' ? (
        <div className="flex items-center">
          <input
            type="checkbox"
            id={name}
            {...(register ? register(name) : {})}
            disabled={disabled}
            checked={!!value}
            className={`w-auto ${className}`}
            {...rest}
          />
          {label && (
            <label htmlFor={name} className="text-sm md:text-md ml-2">
              {label}
            </label>
          )}
        </div>
      ) : type === 'select' ? (
        <select
          {...register(name)}
          disabled={disabled}
          className={`border w-full px-3 py-[12px] rounded ${
            hasError ? 'border-red-500' : ''
          } ${className}`}
          {...rest}
          value={value}
          onChange={onChange}
        >
          <option value="">Select {label}</option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ) : type === 'date-picker' ? (
        <Controller
          name={name}
          control={control}
          rules={{
            required: required ? `${placeholder || name} is required` : false,
          }}
          render={({ field: { onChange: controllerChange, value } }) => (
            <Datepicker
              placeholder={placeholder}
              useRange={false}
              asSingle={true}
              name={name}
              className="w-full"
              inputClassName={`border w-full px-3 py-[12px] rounded ${
                hasError ? 'border-red-500' : ''
              } ${className}`}
              min={min}
              max={max}
              minDate={minDate}
              disabled={disabled}
              onChange={(date) => {
                if (onChange) {
                  onChange(date);
                }
                controllerChange(date?.startDate ?? null);
              }}
              value={{ startDate: value, endDate: value }}
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              {...rest}
            />
          )}
        />
      ) : (
        <div>
          <div className="relative">
            <input
              type={type}
              placeholder={placeholder}
              {...(register ? register(name) : {})}
              disabled={disabled}
              readOnly={readOnly}
              value={value}
              className={`border w-full px-3 py-[10px] pr-12 rounded ${
                hasError ? 'border-red-500' : ''
              } ${className}`}
              min={min}
              max={max}
              {...rest}
            />
            {append && append}
          </div>
        </div>
      )}

      {showCopy && valueToCopy && disabled && (
        <CopyToClipboard
          text={valueToCopy}
          onCopy={onCopy}
          className="absolute top-1/2 right-3 z-10 w-6 h-6 -translate-y-1/2 cursor-pointer mt-3"
          style={{ transform: 'translateY(-50%)' }}
        >
          <span>
            <CopySignIcon />
          </span>
        </CopyToClipboard>
      )}

      {hasError && (
        <p className="text-red-500 text-xs mt-1">{hasError.message}</p>
      )}
    </div>
  );
};

export default FormInput;
